import { getRoot, types } from 'mobx-state-tree'
import { IPartners } from '../Partners'
import { IAuth } from '../Auth'
import { IConversations } from '../Conversations'
import { IDownloads } from '../Downloads'

interface IRootAccess {
  auth: IAuth
  partners: IPartners
  conversations: IConversations
  downloads: IDownloads
}

export const RootAccessable = types.model({}).actions((self) => ({
  getAuth(): IAuth {
    const { auth } = getRoot(self) as IRootAccess
    return auth
  },
  getPartners(): IPartners {
    const { partners } = getRoot(self) as IRootAccess
    return partners
  },
  getConversations(): IConversations {
    const { conversations } = getRoot(self) as IRootAccess
    return conversations
  },
  getDownloads(): IDownloads {
    const { downloads } = getRoot(self) as IRootAccess
    return downloads
  }
}))
